import httpClient from '../httpClient';

export async function getAllOrgInters() {
  try {
    const response = await httpClient.get(`/api/orginter`);

    // Verifica se response.data existe antes de acessar registros
    if (!response.data || !Array.isArray(response.data.registros)) {
      console.warn('API retornou um formato inesperado:', response.data);
      return [];
    }

    return response.data.registros;
  } catch (error) {
    console.error('Erro ao obter dados:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}

export async function getOrgInter(id: string | number) {
  try {
    const response = await httpClient.get(`/api/orginter/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getOrgIntersByUsuario() {
  try {
    const response = await httpClient.get(
      `/api/orginter/orginters-por-usuario`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error(
      'Erro ao obter Organismos Internacionais do usuário: ' + error,
    );
  }
}
